export const painPoints = [
  {
    emoji: '🧭',
    title: 'Vous ne savez pas toujours par où commencer',
    desc: 'Vous avez les informations, mais elles sont dispersées dans des notes, des éléments chronologiques, des observations ou plusieurs sources. SIGMA SMART™ vous aide à partir d’une structure claire.',
  },
  {
    emoji: '📝',
    title: 'Vous passez trop de temps à formuler vos demandes à l’IA',
    desc: 'Une IA peut être très performante… mais une demande vague produit souvent une réponse vague. Les prompts SIGMA SMART™ vous donnent une structure prête à personnaliser.',
  },
  {
    emoji: '🧩',
    title: 'Vous obtenez parfois des réponses trop génériques',
    desc: 'Vous avez besoin d’un document professionnel adapté à votre contexte. Les prompts vous permettent de préciser : le contexte → les faits → l’objectif → la structure → les informations disponibles.',
  },
  {
    emoji: '⏱️',
    title: 'Vous voulez réduire le temps passé à organiser vos documents',
    desc: 'Après une intervention, une audition ou une journée chargée, la dernière chose dont vous avez besoin est de repartir d’une page blanche. Une structure claire réduit les allers-retours avec l’IA.',
  },
];
